import { render, staticRenderFns } from "./patch.vue?vue&type=template&id=1f6852ee&scoped=true"
import script from "./patch.vue?vue&type=script&lang=js"
export * from "./patch.vue?vue&type=script&lang=js"
import style0 from "./patch.vue?vue&type=style&index=0&id=1f6852ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6852ee",
  null
  
)

export default component.exports